import './App.css';
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { FacebookProvider, CustomChat } from 'react-facebook';

// ✅ Lazy load all pages — only loads when user visits that route
const LandingPage   = lazy(() => import('./Pages/LandingPage/LandingPage'));
const Directory     = lazy(() => import('./Pages/Directory/directory'));
const StoreDetails  = lazy(() => import('./Pages/StoreDetails/Store'));
const AboutUs       = lazy(() => import('./components/AboutUs/AboutUs'));

// ✅ Loading spinner shown while lazy components load
function PageLoader() {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#888',
    }}>
      Loading...
    </div>
  );
}

function App() {
  // ✅ REMOVED: manual Facebook SDK useEffect
  // It was loading the SDK a second time, doubling the JS cost (59 KiB wasted).
  // react-facebook's <FacebookProvider> already handles SDK loading automatically.

  return (
    <div>
      <Router>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/"         element={<LandingPage />} />
            <Route path="/AboutUs"  element={<AboutUs />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/Store"    element={<StoreDetails />} />
          </Routes>
        </Suspense>
      </Router>

      {/* ✅ FacebookProvider loads SDK once, lazily, via react-facebook */}
      <FacebookProvider
        appId="783481226703777"
        lazy={true}  // ← only loads Facebook SDK when chat widget is needed
      >
        <CustomChat
          pageId="106034028441299"
          themeColor="#0084ff"
          loggedInGreeting="Hi! How can we help you today?"
          loggedOutGreeting="Hi! Please log in to chat with us."
        />
      </FacebookProvider>
    </div>
  );
}

export default App;